import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: 'bcf9b34a-d0dd-4f24-a6c7-ff209c617444',
    countryCodes: ['NO'],
    locale: 'no-NO',
    enable: {
        prelaunch: true,
    },
});
